__turbopack_context__.v({
  "component": "style-module-scss-module__A4aDrq__component",
  "custom-tooltip-position": "style-module-scss-module__A4aDrq__custom-tooltip-position",
  "icon": "style-module-scss-module__A4aDrq__icon",
});
